import { PagingExpander } from "../../Components/Paging/paging-expander.js";
import Analytics from "../../../frontend/js/analytics.js";
import Cookies from 'js-cookie';

class Search {
    constructor() {
        if (document.querySelector('.search') === null)
            return;

        this.form = document.querySelector('.search-hero__form--search-form');
        this.targetContainer = document.querySelector('#search-container');
        this.result = document.querySelector('.search__hits');
        this.bindFunctions();
        this.initializeChips();
        this.addLoginListeners();

        this.initializeSubmitButton();
        this.initializeClearButtons();
        this.setClearFilterButtonVisibility();
        this.addGoogleAnalyticsEventListeners();

        this.form.addEventListener('submit', this.onFormSubmit);
        this.form.addEventListener("change", e => e.currentTarget.requestSubmit());

        this.handlePossibleScroll();
        new PagingExpander();

        const formData = new FormData(this.form);
        const query = formData.get("q");
        this.storeInSearchHistoryCookie(query);
        this.AbortController = new AbortController();
    }

    handlePossibleScroll = () => {
        const parameters = new URLSearchParams(window.location.search);
        const currentPage = parameters.get('p');

        if (currentPage) {
            const container = this.targetContainer;
            setTimeout(function () {
                container.scrollIntoView({ behavior: 'smooth' });
            }, 250);
        }
    }

    initializeClearButtons = () => {
        const form = document.querySelector('.search-hero__form--search-form');
        const clearButtons = [...document.querySelectorAll('button[data-searchfilterclear]')];

        clearButtons.forEach((clearButton) => {
            clearButton.addEventListener(`click`, function () {
                clearButton.dataset.searchfilterclear.split(',').forEach((formElementName) => {
                    const formElement = form.querySelector(`[name="${formElementName}"]`);
                    if (formElement) {
                        formElement.value = '';
                    }
                });

                const allChipRadioButton = document.querySelector('.search-hero__chip-radio#all-pages');
                allChipRadioButton.dispatchEvent(new Event('click'));
                form.dispatchEvent(new Event('submit'));
            });
        });
    }

    initializeSubmitButton = () => {
        this.form.querySelector("button[type=submit]").addEventListener("click", e => {
            if (e.pointerType) {
                window.scrollTo({ top: this.result.offsetTop });
            }
        });
    }

    addLoadingDots = () => {
        const result = document.querySelector('.search__hits');

        result.innerHTML = "";
        const loadingContainer = document.createElement("div");
        const loadingDots = document.createElement("div");
        loadingContainer.classList.add("search__loader");

        loadingDots.classList.add("loading-dots");
        for (let i = 0; i < 4; i++) {
            loadingDots.appendChild(document.createElement("div"));
        }
        loadingContainer.appendChild(loadingDots)
        result.appendChild(loadingContainer);
    }

    removeLoadingDots = () => {
        const loadingDots = document.querySelector(".search__loader");
        if (loadingDots) {
            loadingDots.remove();
        }
    }

    initializeChips = () => {
        const chips = document.querySelector('.search-hero__chips');

        if (!chips) {
            return;
        }

        const radioButtons = [...chips.querySelectorAll('input[type=radio]')];

        radioButtons.forEach((radioButton) => {
            radioButton.addEventListener(`click`, function (e) {
                radioButtons.forEach((r) => {
                    r.parentElement.classList.remove('search-hero__chip--selected');
                    r.parentElement.classList.add('search-hero__chip--inactive');
                    r.checked = false;
                });

                e.target.parentElement.classList.add('search-hero__chip--selected');
                e.target.parentElement.classList.remove('search-hero__chip--inactive');
                e.target.checked = true;
            });
        });
    }

    onFormSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const formData = new FormData(event.currentTarget);
        const urlParams = new URLSearchParams(formData);
        this.getData(urlParams.toString());

        const query = formData.get("q");
        if (query) {
            this.storeInSearchHistoryCookie(query);
        }
    }

    storeInSearchHistoryCookie = (searchTerm) => {
        const cookieName = "prev-search-terms";
        let previousSearchTerms = Cookies.get(cookieName) ? JSON.parse(Cookies.get(cookieName)) : [];

        const trimmedSearchTerm = searchTerm.trim();

        if (trimmedSearchTerm && !previousSearchTerms.includes(trimmedSearchTerm)) {
            if (previousSearchTerms.length >= 5) {
                previousSearchTerms.shift();
            }
            previousSearchTerms.unshift(trimmedSearchTerm);
            Cookies.set(cookieName, JSON.stringify(previousSearchTerms), { expires: 365 });
        }
    }

    getData = (query) => {
        if (this.targetContainer.classList.contains('search-loading'))
            return;
        if (this.AbortController) {
            this.AbortController.abort();
        }

        this.AbortController = new AbortController();

        this.addLoadingDots();

        const url = `${location.pathname}?${query}`;
        history.pushState("", "", url);
        const headers = {
            'pragma': 'no-cache',
            'cache-control': 'no-cache',
            'X-Requested-With': 'XMLHttpRequest'
        };
        fetch(url, {
            method: 'GET',
            headers,
            signal: this.AbortController.signal,
            credentials: 'same-origin'
        })
            .then(res => res.json())
            .then(this.onFinish)
            .catch(err => console.log(err))
            .finally(this.initializeClearButtons);
    }

    updateChipCounters = () => {
        const chipsContainerElement = document.querySelector('.search-hero__chips');
        const searchDataElement = document.querySelector('#search-data');

        if (!chipsContainerElement || !searchDataElement)
            return;

        const labels = chipsContainerElement.querySelectorAll('label');

        let allCount = 0;

        Array.from(labels).slice(1).forEach(label => {
            const forAttribute = label.getAttribute('for');
            const count = Number(searchDataElement.getAttribute(`data-${forAttribute}`));
            allCount += count;
            label.setAttribute('data-count', count);
            label.querySelector('.search-hero__chip-count').innerHTML = `(${count})`;
        });

        labels[0].querySelector('.search-hero__chip-count').innerHTML = `(${allCount})`;
        labels[0].setAttribute('data-count', allCount);
    }

    updateDropdowns = () => {
        const scripts = document.querySelectorAll('script#search-meta-data');
        scripts.forEach(script => eval(script.innerHTML)); // TODO: Fix this

        const selectBranch = document.getElementById("branch");
        const selectType = document.getElementById("type");
        selectType.innerHTML = '';
        selectBranch.innerHTML = '';

        window.branchData.forEach((branch) => {
            const option = document.createElement("option");
            option.value = branch.value;
            option.selected = branch.selected;
            option.text = branch.description;
            selectBranch.appendChild(option);
        });

        window.contentTypeData.forEach((type) => {
            const option = document.createElement("option");
            option.value = type.value;
            option.selected = type.selected;
            option.text = type.description;
            selectType.appendChild(option);
        });
    }

    setClearFilterButtonVisibility() {
        const form = document.querySelector('.search-hero__form--search-form');
        const button = document.querySelector('.search__filter-clear-all');
        const toggleClass = 'search__filter-clear-all--hidden';

        const formData = new FormData(form);
        const filteredValues = Array.from(formData.entries()).filter(([name, value]) => name !== 'q').map(([name, value]) => value);
        const hasValue = filteredValues.some(value => value && value !== 'all');
        button.classList.toggle(toggleClass, !hasValue);
    }

    addLoginListeners = () => {
        const loginHits = [...document.querySelectorAll('.search-hit__link--login')];

        loginHits.map((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();

                const loginDialog = document.querySelector('#login');
                loginDialog.classList.add('dialog--open');

                const loginModal = loginDialog.querySelector('.login');
                loginModal.classList.add('login--open');
                loginModal.inert = false;

                const loginForm = document.querySelector('#login form');
                const urlWithoutParams = loginForm.action.split('?')[0];

                const anchor = document.createElement('a');
                anchor.href = e.currentTarget.href;

                loginForm.action = `${urlWithoutParams}?returnUrl=${anchor.pathname}${anchor.search}`;

                window.scroll({
                    top: 0,
                    behavior: 'smooth'
                });
            });
        });
    }

    onFinish(json) {
        this.removeLoadingDots();
        this.result.innerHTML = json.hits;
        this.updateChipCounters();
        this.updateDropdowns();
        this.setClearFilterButtonVisibility();
        this.addLoginListeners();
        new PagingExpander();
    }

    bindFunctions() {
        this.onFormSubmit = this.onFormSubmit.bind(this);
        this.sendData = this.getData.bind(this);
        this.onFinish = this.onFinish.bind(this);
    }

    addGoogleAnalyticsEventListeners() {
        const dropdownInteractions = {
            branch: 'Bransch',
            type: 'Ämne'
        };

        const dropdowns = document.querySelectorAll('.search-hero__form--search-form select');
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('change', (e) => {
                const selectedValue = e.target.value;
                const selectedName = e.target.name;
                const optionInnerText = e.target.options[e.target.selectedIndex].innerText;
                const selectedLabel = dropdownInteractions[selectedName];

                if (!selectedValue || !optionInnerText) {
                    return;
                }

                if (selectedValue) {
                    const data = {
                        'event': 'searchFilter',
                        'filterType': selectedLabel,
                        'filterValue': optionInnerText,
                        'isAuthenticated': Analytics.getAuthenticated(),
                        'selectedBranch': Analytics.getBranchName()
                    };
                    window.dataLayer.push(data);
                }
            });
        });

        const getTextNode = (target) => {
            const children = [...target.childNodes]
            const tabText = children.filter(x => x.nodeType === Node.TEXT_NODE);
            for (let i = 0; i < tabText.length; i++) {
                if (tabText[i].nodeValue.trim().length > 0) {
                    return tabText[i].nodeValue.trim();
                }
            }
            return ""
        }

        const tabs = document.querySelectorAll('.search-hero__chip');
        tabs.forEach(tab => {
            tab.addEventListener('click', (e) => {
                const text = getTextNode(e.currentTarget);
                if (!text || e.currentTarget !== e.target) { // stop checkbox from triggering this event again
                    return;
                }

                const data = {
                    'event': 'searchTabs',
                    'searchTab': text,
                    'isAuthenticated': Analytics.getAuthenticated(),
                    'selectedBranch': Analytics.getBranchName()
                };
                window.dataLayer.push(data);
            });
        })

        const searchInput = document.querySelector('.search-hero__input.search-hero__input--search') || document.createElement('input');

        searchInput.addEventListener('blur', (e) => {
            if (!searchInput.value || !searchInput.value?.trim().length) {
                return;
            }

            const data = {
                'event': 'searchGlobal',
                'searchTerm': searchInput.value,
                'isAuthenticated': Analytics.getAuthenticated(),
                'selectedBranch': Analytics.getBranchName()
            };
            window.dataLayer.push(data);
        });
    }
}

document.addEventListener("DOMContentLoaded", () => {
    new Search();
});
